import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DirectionStack from './DirectionStack';
import ClientProvider from './client';
export default createDemo(import.meta.url, DirectionStack, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/stack/demos/direction/DirectionStack.tsx",
    "fileName": "DirectionStack.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Paper from '@mui/material/Paper';\nimport Stack from '@mui/material/Stack';\nimport { styled } from '@mui/material/styles';\n\nconst Item = styled(Paper)(({ theme }) => ({\n  backgroundColor: '#fff',\n  ...theme.typography.body2,\n  padding: theme.spacing(1),\n  textAlign: 'center',\n  color: (theme.vars ?? theme).palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n  }),\n}));\n\nexport default function DirectionStack() {\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Stack direction=\"row\" spacing={2}>\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Stack>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 26,
        "focusedLines": 5,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Paper from '@mui/material/Paper';\nimport Stack from '@mui/material/Stack';\nimport { styled } from '@mui/material/styles';\n\nconst Item = styled(Paper)(({ theme }) => ({\n  backgroundColor: '#fff',\n  ...theme.typography.body2,\n  padding: theme.spacing(1),\n  textAlign: 'center',\n  color: (theme.vars ?? theme).palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n  }),\n}));\n\nexport default function DirectionStack() {\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Stack direction=\"row\" spacing={2}>\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Stack>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Stack"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "direction"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "row",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "spacing"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "2"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Item 1</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Item 2</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Item 3</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Stack"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 26,
    "focusedLines": 5,
    "collapsible": true,
    "externals": [
      "@mui/material/Paper",
      "@mui/material/Stack",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
